import * as React from 'react';
import { connect } from 'react-redux';

import {
    Col,
    Container,
    Row
} from 'reactstrap';

import '../Main.scss';

import { BusyWindowWrapper } from '../LoadingMessageWithIndicator/BusyWindowWrapper';
import { SubmissionHistory } from '../SubmissionHistory/SubmissionHistory';

import { ApplicationState } from '../../Store';
import { GetPortalBusyState } from '../../Store/UIState';
import { GetPortalText } from '../../Store/PortalAssets';

import { InlineStylingValues, pathConstants } from '../../Utils/Constants';

import { BreadCrumbs } from '../BreadCrumbs/BreadCrumbs';

import { PortalTextCommon, PortalTextSubmissionDetails } from '../../Models/Api/strongbox.financialportal';

type InjectedReduxState = {
    portalBusy: boolean;
    commonText?: PortalTextCommon;
    submissionDetailsText?: PortalTextSubmissionDetails;
};

type InjectedActionCreators = {};

type DataCollectionReportProps = {
}

type Props = DataCollectionReportProps & InjectedActionCreators & InjectedReduxState;

const DataCollectionReportComponent: React.FC<Props> = (props): React.ReactElement => {
    return (
        <div
            style={{
                position: 'absolute',
                width: '100%',
                minWidth: '20px'
            }}
            className={`free-content-region contained-content control-region control-region-lender`}
        >
            <Container 
                style={{
                    marginTop: InlineStylingValues.BasicSectionSeparation,
                }}
                fluid
            >
                {!!props.commonText && !!props.submissionDetailsText && (
                    <Row>
                        <Col>
                            <BreadCrumbs
                                crumbs={[
                                    {
                                        content: props.commonText?.breadcrumbWorkspaceList || '' ,
                                        link: pathConstants.home,
                                    },
                                    {
                                        content: props.submissionDetailsText?.dataCollectionReport || '',
                                    }
                                ]}
                            />
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col>
                        <BusyWindowWrapper
                            portalBusy={props.portalBusy}
                            workingText={props.commonText?.working || ''}
                        >
                            <SubmissionHistory
                                submissionDetailsBase={pathConstants.allSubmissionDetails}
                            />
                        </BusyWindowWrapper>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export const DataCollectionReport = connect<InjectedReduxState, InjectedActionCreators, DataCollectionReportProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result = {
            portalBusy: GetPortalBusyState(appState),
            commonText: GetPortalText<PortalTextCommon>(appState, 'commonText'),
            submissionDetailsText: GetPortalText<PortalTextSubmissionDetails>(appState, 'submissionDetails'),
        };

        return result;
    }
)(DataCollectionReportComponent);

